import { render, staticRenderFns } from "./costPerSector.vue?vue&type=template&id=6ee8ec12&scoped=true"
import script from "./costPerSector.vue?vue&type=script&lang=js"
export * from "./costPerSector.vue?vue&type=script&lang=js"
import style0 from "./costPerSector.vue?vue&type=style&index=0&id=6ee8ec12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ee8ec12",
  null
  
)

export default component.exports